"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'onboarding.button.start': 'Iniciar onboarding',
    'onboarding.button.continue': 'Continuar a los Pasos',
    'onboarding.button.previous': 'Anterior',
    'onboarding.button.next': 'Siguiente',
    'onboarding.button.complete': 'Completar Onboarding',
};
